export const SETTINGS_CHANGE_REDUCER = 'SETTINGS_CHANGE_REDUCER';
export const SETTINGS_CHANGE_FIELD = 'SETTINGS_CHANGE_FIELD';
export const SETTINGS_CHANGE_LAYOUT = 'SETTINGS_CHANGE_LAYOUT';